import React, { useRef, useState } from "react";
import { Button, Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import Header from "../../../../components/headers/Header";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/agent/bankcard/EditRedux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useForm } from "react-hook-form";

import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import "antd/dist/antd.css";
import { bankList } from "../../../../assets/bank/banks.json";

const uid = UIDs.screens.admin.agent.bankcard.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.SAVE_BANK_CARD_ASYNC]: { done: this._handleSaveBankCardAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.create();
    }

    render() {
        const { bankCardInfo } = this.props.localState;
        return (
            <>
                {!bankCardInfo || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                    ? <LoadingIndicator />
                    : <EditForm
                        {...this.props} 
                        bankCardInfo={bankCardInfo} 
                        onSave={this._handleSaveInfo} 
                        onBack={this._handleBack}
                        type = {this.localVars.navParams.type}
                        isDisabled={this.isActionExecuting(ActionTypes.SAVE_BAND_CARD_ASYNC)}
                    />
                }
            </>
        );
    }

    _handleSaveInfo = (data) => {
        const { userrole } = this.localVars.navParams;
        let { type } = this.localVars.navParams;
        if(!type)
            type = 1;
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { data: {type: parseInt(type), description: data.description}, partnerId: this.props.partnerId, userRole: userrole };
                        this.props.saveBankCardAsync(data);
                    },
                },
                {
                    label: this.props.t("no"),
                },
            ],
        });
    };

    _handleBack = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };

    _handleSaveBankCardAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

}

function EditForm(props) {
    const { data } = props.bankCardInfo;
    const { register, handleSubmit, errors, clearError } = useForm();
    const submitRef = useRef();
    const type = props.type;

    let dataContent = null;
    switch(type){
        case 1: //通用
        default: //通用
            const description = data && data.description;
            dataContent = (
                <div className="col-lg-12">
                    <div className="form-group">
                        <label className="form-control-label">{props.t("bankAccount")}</label>
                        <textarea
                            className="form-control-alternative form-control"
                            name="description"
                            defaultValue={description}
                            type="text"
                            rows={5}
                            placeholder={props.t("bankAccountDescr")}
                            ref={register({
                                required: props.t("fieldIsRequired")
                            })}
                        />
                        {errors.description && <span className="text-danger">{errors.description.message}</span>}
                    </div>
                </div>
            );
            break;
    }

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <Row>
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{props.t("addBankCard")}</h3>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button color="primary" disabled={props.isDisabled} onClick={() => submitRef.current.click()} size="sm">
                                                {props.t("agreeBind")}
                                            </Button>
                                            <Button color="default" disabled={props.isDisabled} onClick={() => props.onBack()} size="sm">
                                                {props.t("back")}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            {dataContent}
                                        </div>
                                    </div>
                                    <input ref={submitRef} type="submit" hidden />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </form>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveBankCardAsync: (vo) => dispatch(Actions.saveBankCardAsync(vo)),
        create: () => dispatch(Actions.create())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
